var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.shouldShowPicker,
                      expression: "!shouldShowPicker",
                    },
                  ],
                  on: { click: _vm.chooseVan },
                },
                [_vm._v(_vm._s(_vm.buttonLabel))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedVan,
                      expression: "selectedVan",
                    },
                  ],
                  on: { click: _vm.clearVan },
                },
                [_vm._v("Clear")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.shouldShowPicker
            ? _c(
                "v-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-col", { attrs: { cols: "10" } }, [
                            _c(
                              "div",
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "hide-details": "",
                                    required: this.field.required,
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      return _vm.updateVanNumber()
                                    },
                                  },
                                  model: {
                                    value: _vm.vanViewNumber,
                                    callback: function ($$v) {
                                      _vm.vanViewNumber = $$v
                                    },
                                    expression: "vanViewNumber",
                                  },
                                }),
                                _vm._v(" "),
                                this.selectedVan != null
                                  ? _c(
                                      "span",
                                      [
                                        _vm._v("provided by "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.providersById[
                                                this.selectedVan
                                                  .van_provider_key
                                              ].van_provider_name
                                            )
                                          ),
                                        ]),
                                        _vm._v(
                                          ", value " +
                                            _vm._s(
                                              _vm.selectedVan.amount
                                                ? _vm.selectedVan.amount
                                                : "N/A"
                                            ) +
                                            " GBP "
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              href: _vm.selectedVan.url,
                                            },
                                          },
                                          [_vm._v("View Card")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.vanOptions.length && _vm.shouldShowVans
                              ? _c(
                                  "div",
                                  { staticClass: "selectable-vans-results" },
                                  [
                                    _c(
                                      "ul",
                                      { staticClass: "selectable-vans-list" },
                                      _vm._l(_vm.vanOptions, function (van) {
                                        return _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectVan(
                                                  van.van_key
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.providersById[
                                                  van.van_provider_key
                                                ].van_provider_name
                                              ) +
                                                " -\n                                                                                " +
                                                _vm._s(van.van_number) +
                                                " (" +
                                                _vm._s(
                                                  van.amount
                                                    ? van.amount
                                                    : "N/A"
                                                ) +
                                                " GBP)"
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: _vm.field.fieldName },
            domProps: { value: _vm.field.value },
          }),
          _vm._v(" "),
          _vm.errorMessages && _vm.errorMessages.length
            ? _c(
                "v-alert",
                { attrs: { type: "error", dismissable: "", value: "true" } },
                _vm._l(_vm.errorMessages, function (error, index) {
                  return _c("div", { key: index }, [
                    _vm._v(_vm._s(error.reason) + "*"),
                  ])
                }),
                0
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }